<div id="id01">
  <header>
    <h1 id="hcs" class="px-3 py-2"> {{nodeDetails?.humanCodingScheme}}</h1>
  </header>
  <main class="content px-3">
    <p class="mb-0" id="fullStatement">{{nodeDetails?.fullStatement}}</p>
  </main>
</div>